import React, { useState } from "react";
import { MenuIcon } from "../icons/menu.tsx";
import { Container } from "../styled.ts";
import { CrossIcon } from "../icons/cross.tsx";

export const Hamburger = ({ isOpen, toggleOpen }) => {
  return (
    <>
      <Container
        column
        radius="100px"
        justifyContent="center"
        color="white"
        padding="10px"
        onClick={toggleOpen}
      >
        {isOpen ? <CrossIcon /> : <MenuIcon />}
      </Container>
    </>
  );
};
